import request from 'axios'
/** 分页获取绑定设备记录 */
export const getBindDeviceRecordList = (params) => {
  return request({
    url: '/lebo-member/web/partner/bind-device/list',
    method: 'get',
    params
  })
}
/** 导出绑定设备记录 */
export const exportBindDeviceRecord = (params) => {
  return request({
    url: '/lebo-member/web/partner/bind-device/export',
    method: 'get',
    params,
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/octet-stream"
    }
  })
}
